import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useState } from "react";
import { succsesDataAddAlert, succsesDataChangeAlert } from "../../alerts/alerts";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const Request = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const [status, setStatus] = useState(1);
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [product, setProduct] = useState("");

    const { data: statuces } = useGetPageQuery("request-statuses");
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const sendFormHandler = async () => {
        const formData = {
            request_status_id: status,
            name: name,
            phone: phone,
            product: product,
        };

        await sendForm({ body: formData, url: "requests", method: "POST" }).unwrap();

        if (!isError) {
            succsesDataAddAlert();
            navigate("/requests");
        }
    };

    return (
        <>
            {statuces && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Додати Запит</h1>
                        </div>
                        <div className="form user_form">
                            <input type="hidden" name="id" value="" />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">Інформація про запит</div>
                                        <div className="card-body">
                                            <div className="form-group mb-3">
                                                <label className="form-label">Статус</label>
                                                <select
                                                    name="status"
                                                    className="form-select"
                                                    value={status}
                                                    onChange={(e) => setStatus(e.target.value)}
                                                >
                                                    {statuces.map((status) => {
                                                        return <option value={status.id}>{status.title}</option>;
                                                    })}
                                                </select>
                                            </div>

                                            <div className="form-group mb-3">
                                                <label className="form-label">Назва</label>
                                                <input
                                                    className="form-control"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    name="name"
                                                    maxLength="255"
                                                    type="text"
                                                    required=""
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label className="form-label">Телефон</label>
                                                <input
                                                    className="form-control"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    maxLength="255"
                                                    type="text"
                                                    required=""
                                                />
                                            </div>
                                            <div className="form-group mb-3">
                                                <label className="form-label">Товар</label>
                                                <input
                                                    className="form-control"
                                                    value={product}
                                                    onChange={(e) => setProduct(e.target.value)}
                                                    maxLength="255"
                                                    type="text"
                                                    required=""
                                                />
                                            </div>
                                            {permissions.includes("request_edit") || permissions.includes("all") ? (
                                                <button className="btn btn-primary" onClick={sendFormHandler}>
                                                    {isLoading ? "Завантаження" : "Зберегти"}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-lg-6"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Request;
